// TweetList
import React from 'react';
import { useState, useEffect, useCallback } from 'react';
import Tweet from './Tweet';
import { useAuth0 } from '@auth0/auth0-react';
import { useTwitterContext } from '../TwitterContext';

const TweetList = () => {
  const [tweets, setTweets] = useState([]);
  const { isLoading } = useAuth0();
  const { filter } = useTwitterContext();

  const getTweets = useCallback(async () => {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/tweets`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    let result = await data.json();
    result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (filter) {
      result = result.filter((tweet) => {
        return (
          (filter.user && tweet.user.id === filter.user) ||
          (filter.text && tweet.text.includes(filter.text)) ||
          (filter.userName && tweet.user.name.includes(filter.userName))
        );
      });
    }
    setTweets(result);
  }, [filter]); // Dependency array includes filter
  
  useEffect(() => {
    setTweets([]);
    getTweets();
  }, [getTweets, filter]);

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="tweet-list">
      {tweets.map((tweet) => (
      <Tweet key={tweet.id} tweet={tweet} user={tweet.user} />
      ))}
    </div>
  );
};

export default TweetList;
